module.exports = __webpack_public_path__ + "static/media/house-1.5120ad22.jpeg";